import './styles.scss'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CoffeeWebLogo, devEnvLogo } from 'Assets/Icons'
import { ROUTE_STRINGS } from 'Utils/Constants'
import { getLocalUserDetails, getLocalAuthToken, setLocalWithAppSettings } from 'Utils/LocalStorageHandler'
import apiAdapterCoffeeWeb from 'Services/apiAdapterCoffeeWeb'
import Header from 'Components/Routes/Components/Header'
import Loader from 'Components/Loader'
import DialogModal from 'Components/UIComponents/DialogModal'
import ResetPasswordModal from './Components/ResetPasswordModal'
import LoginComponent from './Components/LoginComponent'

const LoginScreen = ({ setLoading }) => {
  const history = useHistory()

  const { t } = useTranslation()
  const userDetails = getLocalUserDetails()
  const accessToken = getLocalAuthToken()
  const tabId = sessionStorage.tabId ? sessionStorage.tabId : (sessionStorage.tabId = Math.random())

  window.sessionStorage.setItem('tabId', tabId)

  const [passwordResetVia, setPasswordResetVia] = useState('phone')
  const [generatedToken, setGeneratedToken] = useState('')
  const [resetModal, setResetModal] = useState(false)
  const [resetError, setResetError] = useState(true)
  const [isRequestOtpClicked, setIsRequestOtpClicked] = useState(false)
  const [modalState, setModalState] = useState({
    showModal: false,
    modalType: '',
    message: ''
  })

  const params = new URLSearchParams(history.location.search)
  const authModParam = params.get('authMod')

  if (userDetails && accessToken && !authModParam) {
    history.push(ROUTE_STRINGS.coffeequotes)
  } else if (authModParam) {
    localStorage.clear()
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    const search = history.location.search

    if (search === `${'?'}${ROUTE_STRINGS.resetViaPhone}`) {
      setResetModal(true)
    } else if (search === `${'?'}${ROUTE_STRINGS.resetViaEmail}` || search.startsWith(`${'?'}${ROUTE_STRINGS.resetViaEmail}/`)) {
      setResetModal(true)
    } else {
      setResetModal(false)
    }
  }, [history.location.search])

  const init = async () => {
    try {
      setLoading(true)
      const response = await apiAdapterCoffeeWeb.generateAuthToken()
      const {
        data: { token }
      } = response

      setGeneratedToken(token)
      getAllAppSetting(token)
    } catch {
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  const handleDismiss = () => {
    setModalState({
      ...modalState,
      showModal: false
    })
  }

  const handleResetPasswordClick = () => {
    setResetError(false)
    setResetModal(true)
    const url = {
      pathname: history.location.pathname,
      search: ROUTE_STRINGS.resetViaPhone
    }

    history.push(url)
  }

  const getAllAppSetting = async (token) => {
    setLoading(true)
    try {
      const response = await apiAdapterCoffeeWeb.appSetting(token)
      const data = response.data

      setLocalWithAppSettings(data)
    } catch {
      console.log('failed to get App settings')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Header />
      <div className="auth-screen">
        <div className="auth-screen-container">
          <div className="auth-screen-logo">
            <img alt="logoImage" src={process.env.REACT_APP_NODE_ENV === 'production' ? CoffeeWebLogo : devEnvLogo} />
          </div>
          <div className="auth-screen-tabs">
            <div className={`auth-tabs card ${isRequestOtpClicked && 'auth-tabs-heights'}`}>
              <p className="login-text">{t('LOGIN')}</p>
              <div>
                <LoginComponent generatedToken={generatedToken} setModalState={setModalState} resetError={resetError} setIsRequestOtpClicked={setIsRequestOtpClicked} />
              </div>
              {/* kept it for the future reference */}
              {/* <div>{resetModal && <ResetPasswordModal setResetError={setResetError} resetError={resetError} setResetModal={setResetModal} generatedToken={generatedToken} resetModal={resetModal} setModalState={setModalState} setPasswordResetVia={setPasswordResetVia} passwordResetVia={passwordResetVia} />}</div> */}
            </div>
          </div>
          <DialogModal {...modalState} onDismiss={handleDismiss} onHide={handleDismiss} onSuccess={handleDismiss}></DialogModal>
        </div>
      </div>
    </>
  )
}

export default Loader(LoginScreen)
